export const appsGoneToArbitrationV2 = [
  { app_key: 'equalizer_plus', device_type: 'ios' },
  { app_key: 'beat_looper', device_type: 'ios' },
  { app_key: 'learning_piano', device_type: 'ios' },
  { app_key: 'edjing_mix', device_type: 'ios' },
  { app_key: 'beat_looper', device_type: 'android' },
  { app_key: 'metronome_pro', device_type: 'ios' },
  { app_key: 'metronome_pro', device_type: 'android' },
  { app_key: 'edjing_mix', device_type: 'android' },
  { app_key: 'stems', device_type: 'android' },
  { app_key: 'tuner_guitar', device_type: 'ios' },
  { app_key: 'swipewipe', device_type: 'ios' },
  { app_key: 'learning_guitar', device_type: 'ios' },
  { app_key: 'movie_night', device_type: 'android' },
  { app_key: 'tuner_guitar', device_type: 'android' },
  { app_key: 'scanner', device_type: 'ios' },
  { app_key: 'movie_night', device_type: 'ios' },
  { app_key: 'learning_piano', device_type: 'android' },
  { app_key: 'learning_sampler', device_type: 'ios' },
  { app_key: 'stems', device_type: 'ios' },
  { app_key: 'coachguitar', device_type: 'ios' },
  { app_key: 'procolor', device_type: 'android' },
  { app_key: 'feedpreview', device_type: 'ios' },
  { app_key: 'learning_sampler', device_type: 'android' },
  { app_key: 'bassbooster', device_type: 'ios' },
  { app_key: 'procolor', device_type: 'ios' },
  { app_key: 'sincerely', device_type: 'ios' },
  { app_key: 'stretchy', device_type: 'ios' },
  { app_key: 'pixel_color', device_type: 'ios' },
  { app_key: 'pixel_color', device_type: 'android' },
  { app_key: 'talk_ai', device_type: 'ios' },
  { app_key: 'eatwell', device_type: 'ios' },
  { app_key: 'bananai', device_type: 'ios' },
  { app_key: 'tiles_pop', device_type: 'ios' },
  { app_key: 'cure', device_type: 'ios' },
  { app_key: 'lingo', device_type: 'ios' },
  { app_key: 'snap_grid', device_type: 'ios' },
  { app_key: 'moments', device_type: 'ios' },
  { app_key: 'clam_cam', device_type: 'ios' },
  { app_key: 'noteshelf', device_type: 'ios' },
  { app_key: 'noteshelf', device_type: 'android' },
  { app_key: 'piano_pop', device_type: 'ios' },
  { app_key: 'piano_pop', device_type: 'android' },
  { app_key: 'flora', device_type: 'ios' },
]
